import { Model } from '@danangelus/ngx-app-core';
import { PermissionGroup } from './permission-group.model';

export class Page extends Model {

    id: string | undefined
    applicationId: string | undefined
    parentPageId: string | undefined
    created: string | undefined
    lastModified: string | undefined
    name: string | undefined
    title: string | undefined
    description: string | undefined
    pageUrl: string | undefined
    expertCode: string | undefined
    displayOrder: string | undefined
    locked: boolean | undefined
    groups: PermissionGroup[] = []

    constructor(page?: any) {
        super(page)

        if (page?.groups?.length > 0) {
            this.groups = page.groups.map((group: any) => new PermissionGroup(group.name, group.fullDn))
        }

        if (page?.groups?.length > 0) {
            this.groups = page.groups
        }
    }
}
